module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAXCAMAAAC/B6aqAAAAQlBMVEUAAADBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcGcYqSSAAAAFXRSTlMA9VA/6Y9k38N7MSQZCdKzoXYRhl596fjQAAAAqUlEQVQoz4VS3RqFIAjDytL+y3j/Vz14xdc40m7yG0tgk3KI9IUYMgXm+CVjDpSYObuySxSJ1kk+oyMbpT6tRMsgh64p66Q6LPU0B+nfN2R9Lc5wBugdcDdAZ4JZEXbHuvt+g+zerWexmrS9qC3xnwxOIY8XcwhzksLS+qN2aLUpMAiMfdnFPBseY5S1FYx3YoIgW7E/Gqr7jFhDdZ+lhuoha6g+ylAs+QPvyg0j9s6c4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/arrow-down.png
// module id = 160
// module chunks = 0